import { useContainerWidth } from '@fs/zion-ui'

export default function useIsMobile() {
  const atWidth = useContainerWidth()
  return atWidth({ default: true, lg: false })
}
